import axios from "axios";
import { getToken } from "../../app/auth/authConfig";

const TAGS_EVENT_NAME = "aays-tags-updated";

export const DEFAULT_TAG_OPTIONS = [
  { value: "Supply Chain", label: "Supply Chain" },
  { value: "Finance", label: "Finance" },
];

const sanitizeTag = (name) => (name || "").trim();

const normalizeApiTag = (item) => {
  const cleanName = sanitizeTag(item?.tagName || item?.value || item?.label);
  if (!cleanName) {
    return null;
  }
  return {
    id: item?.id,
    value: cleanName,
    label: cleanName,
    createdBy: sanitizeTag(item?.createdBy) || "Admin",
    createdAt: item?.createdAt || new Date().toISOString(),
  };
};

const getBaseURL = () => `${process.env.REACT_APP_BACKEND_API_URL}/api/tags/`;

export const getTags = async () => {
  try {
    const token = await getToken();
    const response = await axios.get(getBaseURL(), {
      headers: { "oidc-token": token },
    });

    const mapped = (response.data || []).map((item) => normalizeApiTag(item)).filter(Boolean);
    return mapped;
  } catch (error) {
    console.error("Failed to fetch tags from API", error);
    return [];
  }
};

export const getTagOptions = async () => {
  const tags = await getTags();
  return tags.map((tag) => ({ value: tag.value, label: tag.label }));
};

const emitTagsUpdated = () => {
  document.dispatchEvent(new Event(TAGS_EVENT_NAME));
};

export const addTagOption = async (tagName) => {
  const cleanName = sanitizeTag(tagName);
  if (!cleanName) {
    return { success: false, message: "Tag name is required" };
  }

  try {
    const token = await getToken();
    const response = await axios.post(
      getBaseURL(),
      {
        tagName: cleanName,
      },
      {
        headers: { "oidc-token": token },
      }
    );

    emitTagsUpdated();
    return { success: true, data: normalizeApiTag(response.data) };
  } catch (error) {
    const message = error.response?.data?.error || error.response?.data?.message || "Tag creation failed";
    return { success: false, message };
  }
};

export const updateTagOption = async (tagId, tagName) => {
  const cleanName = sanitizeTag(tagName);
  if (!cleanName) {
    return { success: false, message: "Tag name is required" };
  }

  try {
    const token = await getToken();
    await axios.put(
      `${getBaseURL()}${tagId}`,
      { tagName: cleanName },
      {
        headers: { "oidc-token": token },
      }
    );

    emitTagsUpdated();
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.error || error.response?.data?.message || "Tag update failed";
    return { success: false, message };
  }
};

export const removeTagOption = async (tagId) => {
  try {
    const token = await getToken();
    await axios.delete(`${getBaseURL()}${tagId}`, {
      headers: { "oidc-token": token },
    });
    emitTagsUpdated();
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.error || error.response?.data?.message || "Tag delete failed";
    return { success: false, message };
  }
};
